import { NeutralColors } from 'portfolio3/styles';
import { SxStyles } from 'types';

export const root: SxStyles = {
  display: 'grid',
  placeItems: 'center',

  width: '20px',
  height: '100%',
};

export const line: SxStyles = {
  width: '2px',
  height: '100%',
  backgroundColor: NeutralColors.light_neutrals_300,
};

export const dot: SxStyles = {
  position: 'absolute',
  top: 0,
  display: 'grid',
  placeItems: 'center',

  width: '20px',
  height: '20px',
  borderRadius: '50%',
};

export const innerDot: SxStyles = {
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  backgroundColor: NeutralColors.light_neutrals_0,
};

export const year: SxStyles = {
  position: 'absolute',
  top: '12px',

  transform: 'rotate(270deg) translateY(-26px)',

  opacity: 0.4,
  fontWeight: 900,
  fontSize: '20px',
  lineHeight: '24px',
  color: NeutralColors.light_neutrals_500,
};
